import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30ee6172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-dropdown" }
const _hoisted_2 = { class: "text-md text-weight-bold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider my-3" }, null, -1))

import Btn from '@ds/components/Btn/Btn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoDropdown',
  props: {
    userName: {},
    userEmail: {},
    logoutLabel: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.userName), 1),
    _withDirectives(_createElementVNode("p", { class: "text-sm" }, _toDisplayString(_ctx.userEmail), 513), [
      [_vShow, _ctx.userEmail]
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _hoisted_3,
    _createVNode(Btn, {
      label: _ctx.logoutLabel || 'logout',
      class: "width-100 mt-2",
      "aria-label": "logout",
      "icon-name": "bx-log-out",
      variant: "secondary",
      size: "normal",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
    }, null, 8, ["label"])
  ]))
}
}

})